import type { Event as UserEvent } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCollectionHandler } from "./useCollectionHandler"
import { CollectionKey } from "src/types"

export function useUserEventsHandler() {
  return useCollectionHandler<UserEvent>(CollectionKey.UserEvent)
}
